import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../_services';
import { Router } from '@angular/router';
import {ActivatedRoute} from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-update-parameter-detail',
  templateUrl: './update-parameter-detail.component.html',
  styleUrls: ['./update-parameter-detail.component.css']
})
export class UpdateParameterDetailComponent implements OnInit {

  userData:any = [];
  userName = null;
  @Input() industryId: string;
  @Input() type: string;
  getParameterDetailLoader = false;
  route = '';
  parameterDetails = [];
  error = false;
  formErrorParameterName = [];
  formErrorUnit = [];
  realParameterDetails = {};
  updateParameterLoader = false;

  constructor(private activeroute: ActivatedRoute,private router: Router,
              private _service: CommonService) { }

  ngOnInit() {
    this.userData = JSON.parse(localStorage.getItem('userData'));
    if(this.userData){
      this.userName = this.userData['user_profile_id'];
    }

    this.getParameterDetail();
  }

  getParameterDetail(){
    this.getParameterDetailLoader = true;
    this.route  = 'get-ind-parameter-details';
    const token    = localStorage.getItem('userToken');
    this.parameterDetails = [];
    this.realParameterDetails = {};

    let data = {'industry_id':this.industryId};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }

      if(response.status == 200){
        this.getParameterDetailLoader = false;

        if(response.data.length){
          this.parameterDetails = response.data;

          this.realParameterDetails = JSON.stringify(response.data);

        }
      }

    });
  }
  delete(id){
    const apiRoute = "delete-parameter";

    Swal({
      title: 'Are You Sure?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        const param= {
          id: id
        }
        const token    = localStorage.getItem('userToken');
        this._service.postRequestCreator(param, apiRoute, token).subscribe((response: any) => {

          if(response.status == 200){
            Swal('Success', 'Parameter deleted successfully', 'success');
            // location.reload();
            this.getParameterDetail();

          } else if(response.status == 204) {
            localStorage.removeItem('userToken');
            localStorage.removeItem('userData');
            this.router.navigate(['login']);
            // location.reload();
          }else{
            Swal('Oops...', 'Something went wrong!', 'error');
          }

        });

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal(
          'Cancelled',
          'Delete Cancelled.',
          'error'
        );
      }
    });
  }

  validateParameter(parameterNumber){

    this.error = false;

    if(this.parameterDetails[parameterNumber]['paramkey'].trim() && this.parameterDetails[parameterNumber]['paramkey'].trim() != ' '){
      this.formErrorParameterName[parameterNumber] = '';
    }else{
      this.formErrorParameterName[parameterNumber] = 'Parameter name is required';
      this.error = true;
    }

    if(this.parameterDetails[parameterNumber]['stdunit'].trim() && this.parameterDetails[parameterNumber]['stdunit'].trim() != ' '){
      this.formErrorUnit[parameterNumber] = '';
    }else{
      this.formErrorUnit[parameterNumber] = 'Standard unit is required';
      this.error = true;
    }

    if(this.error){
      Swal('Error', 'Please provide complete details!', 'error');
    }else{

      this.updateParameterLoader = true;
      this.route  = 'update-parameter-detail';
      const token = localStorage.getItem('userToken');
      this.parameterDetails[parameterNumber]['real_dataset'] = this.realParameterDetails;
      this.parameterDetails[parameterNumber]['user_id'] = this.userName;
      this.parameterDetails[parameterNumber]['row_number'] = parameterNumber;
      let data = this.parameterDetails[parameterNumber];

      this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

        if(response.status == 204) {
          localStorage.removeItem('userToken');
          localStorage.removeItem('userData');
          this.router.navigate(['login']);
        }

        this.updateParameterLoader = false;
        if(response.status == 200){
          this.getParameterDetail();
          Swal('Success', 'Parameter details updated successfully', 'success');
        }else{
          Swal('Oops...', 'Something went wrong!', 'error');
        }
      });

    }

  }

}
